(function () {
    $(".content").on("click", ".confirmation-dialog", function (e) {
        e.preventDefault();
        var clickedElement = $(this);

        var kendoWindow = $("<div></div>").kendoWindow({
            title: resourceHelper.ConfirmConfirmation.DialogTitle,
            resizable: false,
            modal: true,
            open: function() {
                maximizeKendoWindowOnMobile(this);
            }
        });

        kendoWindow.on("click", ".confirm, .cancel", function () {
            if ($(this).hasClass("cancel")) {
                kendoWindow.data("kendoWindow").close();
            }
        });

        kendoWindow.data("kendoWindow")
            .content($(document.getElementById("confirmation-window")).html)
            .center().open();
    });
})();